export default "assets/images/texture_paragraph-ef0be0e7.png";